import { ElementRef, HostListener, Directive, AfterContentChecked } from '@angular/core';

@Directive({
	selector: '[autosize]'
})

export class AutosizeDirective implements AfterContentChecked {
	
	/**
	 * Constructs class and injects dependencies.
	 *
	 * @param {ElementRef} element
	 */
	constructor(public element: ElementRef) {
	}
	
	/**
	 * Lifecycle hook: Runs adjust function every content check cycle.
	 */
	ngAfterContentChecked(): void {
		this.adjust();
	}
	
	/**
	 * Runs adjust function on every input.
	 */
	@HostListener('input', ['$event.target'])
	onInput(): void {
		this.adjust();
	}
	
	/**
	 * Automatically adjusts height of text area to show all content.
	 */
	adjust(): void {
		this.element.nativeElement.style.overflow = 'hidden';
		this.element.nativeElement.style.height = 'auto';
		this.element.nativeElement.style.height = this.element.nativeElement.scrollHeight + 'px';
	}

}
